export default __webpack_public_path__ + "static/media/lovrican-theme-grey-small.72703ebe.svg";